import * as THREE from "three";
import Experience from "../Experience.js";

export default class Window {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Resource
    this.resource = this.resources.items.windowModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(2.83, -0.6, 1.4);
    this.model.rotateY(Math.PI * 0.5);
    this.model.name = "window";

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }
}
